import Api from 'utils/api';


const useVoyages = () => {
    return {
        getVoyage: Api.voyages.get,
        voyageLoaded: Api.voyages.loaded,
        voyageDeparted: Api.voyages.departed,
        voyageArrived: Api.voyages.arrived,
    }
};

export default useVoyages;
